// utils/getHeaders.js
const getHeaders = (isFormData = false) => {
  const token = localStorage.getItem('accessToken');
  const headers = {};

  // Set content type only for non-FormData requests
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  }

  // Add authorization token if available
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

export default getHeaders;